import { TextEdit } from '../../../plugins/textedit.js';
export default TextEdit;